var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","enable-background":"new 0 0 24 24","height":"24px","viewBox":"0 0 24 24","width":"24px","fill":"#000000"}},[_c('rect',{attrs:{"fill":"none","height":"24","width":"24"}}),_c('polygon',{attrs:{"points":"21,11 21,3 13,3 16.29,6.29 6.29,16.29 3,13 3,21 11,21 7.71,17.71 17.71,7.71"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }